import { Twitter, Send, BarChart3, Rocket } from "lucide-react";
import CopyCA from "./CopyCA";

const SOCIALS = [
  { icon: Twitter, label: "X / Twitter", href: "https://x.com/JETDOGTOKEN", testid: "social-twitter" },
  { icon: Send, label: "Telegram", href: "https://t.me/jetdogtoken", testid: "social-telegram" },
  { icon: BarChart3, label: "DexScreener", href: "https://dexscreener.com/solana/8Bdum5DBYXqqi5BeGej45vKVifELQM7pASUfysLTpump", testid: "social-dexscreener" },
  { icon: Rocket, label: "Pump.fun", href: "https://pump.fun/8Bdum5DBYXqqi5BeGej45vKVifELQM7pASUfysLTpump", testid: "social-pumpfun" },
];

export const Footer = () => {
  return (
    <footer
      className="relative pt-16 pb-8 px-4 md:px-8 border-t border-[rgba(0,229,255,0.2)]"
      style={{ background: "#030308", color: "white" }}
      data-testid="footer"
    >
      <div className="mx-auto max-w-6xl">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <p className="font-accent text-2xl text-[var(--jd-primary)]">stay wet, stay winning</p>
            <h3 className="font-display font-bold text-3xl uppercase mt-1">Join the JetDog crew</h3>
            <p className="mt-3 text-white/60 max-w-sm">
              Tag us, meme us, raid for us. The wave moves when the pack paddles together.
            </p>
          </div>

          <div>
            <h4 className="font-display text-lg uppercase text-[var(--jd-primary)]">Socials</h4>
            <ul className="mt-4 grid grid-cols-2 gap-3">
              {SOCIALS.map((s) => {
                const Icon = s.icon;
                return (
                  <li key={s.label}>
                    <a
                      href={s.href}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-center gap-2 bg-white/5 border border-white/15 rounded-xl px-3 py-2 hover:border-[rgba(0,229,255,0.6)] hover:text-[var(--jd-primary)] transition-colors"
                      data-testid={s.testid}
                    >
                      <Icon size={18} />
                      <span className="font-display uppercase text-xs">{s.label}</span>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-lg uppercase text-[var(--jd-primary)]">Contract</h4>
            <div className="mt-4">
              <CopyCA />
            </div>
            <p className="mt-3 text-xs text-white/50">
              Always verify the contract address against our official socials.
            </p>
          </div>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/50 max-w-2xl">
            $JETDOG is a community meme token. It has no intrinsic value and no expectation of
            financial return. Crypto is highly volatile — only spend what you can afford to lose.
            This site is not financial advice.
          </p>
          <p className="font-display uppercase text-sm tracking-widest text-white/50">
            © {new Date().getFullYear()} JetDog
          </p>
        </div>

        <p
          className="mt-10 font-display font-bold text-[16vw] leading-[0.85] uppercase tracking-tighter select-none"
          style={{ color: "transparent", WebkitTextStroke: "1px rgba(0,229,255,0.12)" }}
          aria-hidden="true"
        >
          JETDOG
        </p>
      </div>
    </footer>
  );
};

export default Footer;
